var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundTitleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.34472 1.876C7.37328 1.72307 7.45443 1.58494 7.57412 1.48554C7.6938 1.38614 7.84447 1.33173 8.00005 1.33173C8.15563 1.33173 8.3063 1.38614 8.42599 1.48554C8.54567 1.58494 8.62682 1.72307 8.65538 1.876L9.35605 5.58133C9.40581 5.84476 9.53383 6.08707 9.7234 6.27664C9.91297 6.46621 10.1553 6.59423 10.4187 6.644L14.1241 7.34466C14.277 7.37323 14.4151 7.45438 14.5145 7.57406C14.6139 7.69374 14.6683 7.84442 14.6683 8C14.6683 8.15557 14.6139 8.30625 14.5145 8.42593C14.4151 8.54561 14.277 8.62677 14.1241 8.65533L10.4187 9.356C10.1553 9.40576 9.91297 9.53378 9.7234 9.72335C9.53383 9.91292 9.40581 10.1552 9.35605 10.4187L8.65538 14.124C8.62682 14.2769 8.54567 14.4151 8.42599 14.5145C8.3063 14.6138 8.15563 14.6683 8.00005 14.6683C7.84447 14.6683 7.6938 14.6138 7.57412 14.5145C7.45443 14.4151 7.37328 14.2769 7.34472 14.124L6.64405 10.4187C6.59429 10.1552 6.46627 9.91292 6.2767 9.72335C6.08713 9.53378 5.84482 9.40576 5.58138 9.356L1.87605 8.65533C1.72312 8.62677 1.58499 8.54561 1.4856 8.42593C1.3862 8.30625 1.33179 8.15557 1.33179 8C1.33179 7.84442 1.3862 7.69374 1.4856 7.57406C1.58499 7.45438 1.72312 7.37323 1.87605 7.34466L5.58138 6.644C5.84482 6.59423 6.08713 6.46621 6.2767 6.27664C6.46627 6.08707 6.59429 5.84476 6.64405 5.58133L7.34472 1.876Z",
    stroke: "#1447E6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.33334V4",
    stroke: "#1447E6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 2.66667H12",
    stroke: "#1447E6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66659 14.6667C3.40297 14.6667 3.99992 14.0697 3.99992 13.3333C3.99992 12.597 3.40297 12 2.66659 12C1.93021 12 1.33325 12.597 1.33325 13.3333C1.33325 14.0697 1.93021 14.6667 2.66659 14.6667Z",
    stroke: "#1447E6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundTitleIcon);
export default __webpack_public_path__ + "static/media/RoundTitleIcon.febe69d79cd5231b8ab98f1bffc83033.svg";
export { ForwardRef as ReactComponent };